import React from 'react'

function LogOut() {
  return (
    <div>
      <h4>You have been logged out.</h4>
    </div>
  )
}

export default LogOut